import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqItems } from "@/mocks/home";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-8 lg:gap-12">
          <Reveal>
            <div className="lg:sticky lg:top-24">
              <SectionHeading
                eyebrow="常见问题"
                title="关于在线观看，你可能想先确认这些"
                desc="下面整理了浏览与播放过程中最常见的几个问题。点击标题即可展开查看具体说明。"
              />
              <div className="mt-6 rounded-lg bg-background-50 border border-background-200 p-5">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  仍有疑问？可在页面底部的反馈说明中了解处理方式，我们会按问题类型分别跟进。
                </p>
              </div>
            </div>
          </Reveal>

          <div className="space-y-3">
            {faqItems.map((item, index) => {
              const isOpen = openId === item.id;
              return (
                <Reveal key={item.id} delay={index * 50}>
                  <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                    <button
                      type="button"
                      onClick={() => toggle(item.id)}
                      className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-base font-bold text-foreground-950">{item.question}</span>
                      <span
                        className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-4 md:px-5 pb-5 -mt-1 animate-soft-fade">
                        <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}